export default `#ifdef GL_ES
  precision highp float;
#endif

attribute float slope;
attribute float height;

varying float vHeight;
varying float vSlope;

void main()
{
  vSlope = slope;
  vHeight = height;

  vec4 mvpPosition = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  bool isPerspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 );
  gl_PointSize = (95.0 / mvpPosition.w) * float(int(isPerspective)) + 6.0 * float(int(!isPerspective));

  gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
}`